module.exports = __webpack_public_path__ + "img/logo.55ce3578.png";